import spinnerHttpRequest from '@/api/spinner-http-request';
import baseHttpRequest from '@/api/base-http-request';
import {
    PointRequestDetailResI,
    UpdatePointProvideRequestDetailRequestBodyT,
} from '@/types/points/api/point-request-detail-api-types';

/**
 * @description 포인트 지급 요청 상세내역 Modal > 지급 요청 상세내역 조회 API
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/포인트/getProvide
 */
export const getPointProvideRequestDetail = async (provideId: number) => {
    const response = await baseHttpRequest.get<PointRequestDetailResI>(
        '/point/provide',
        {
            params: {
                provideId,
            },
        },
    );

    return response.data;
};

/**
 * @description 포인트 지급 요청 상세내역 Modal > 승인 상태의 포인트 예약지급건 취소 요청 API
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/포인트/cancelReservedProvide
 */
export const cancelReservedPointProvideRequest = async (id: number) => {
    const response = await baseHttpRequest.patch<PointRequestDetailResI>(
        '/point/provide/cancel-reserved',
        {
            id,
        },
    );

    return response.data;
};

/**
 * @description 포인트 지급 요청 수정/취소하기 Modal > 지급 요청 수정 API
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/포인트/updateProvide
 */
export const updatePointProvideRequestDetail = async (
    requestBody: UpdatePointProvideRequestDetailRequestBodyT,
) => {
    const response = await spinnerHttpRequest.patch(
        '/point/provide',
        requestBody,
    );

    return response.data;
};

/**
 * @description 포인트 회수 요청 상세내역 Modal > 회수 요청 상세내역 조회 API
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/포인트/getRetrieve
 */
export const getPointRetrieveRequestDetail = async (id: number) => {
    const response = await baseHttpRequest.get<PointRequestDetailResI>(
        '/point/retrieve',
        {
            params: {
                id,
            },
        },
    );

    return response.data;
};

/**
 * @description 포인트 회수 요청 수정/취소하기 Modal > 회수 요청 수정 API
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/포인트/updateRetrieveRequest
 */
export const updatePointRetrieveRequest = async (requestBody: {
    id: number;
    description: string;
}) => {
    const response = await spinnerHttpRequest.patch(
        '/point/retrieve',
        requestBody,
    );

    return response.data;
};

/**
 * @description 포인트 요청 수정/취소하기 Modal > 지급/회수 요청 취소 API
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/포인트/cancelProvide
 * @see https://dev-business-web-api.withinapi.com/swagger-ui/index.html#/포인트/cancelRetrieveRequest
 */
export const cancelPointRequest = async (
    serviceType: 'provide' | 'retrieve',
    id: number,
) => {
    const response = await spinnerHttpRequest.patch(
        `/point/${serviceType}/cancel`,
        {
            id,
        },
    );

    return response.data;
};
